export default __webpack_public_path__ + "static/media/perfil.48a41b63.webp";